import { useIntl } from "react-intl";
import { camelCaseToTitle } from "features/helpers/utils";

export function useMappingLabel() {
  const { formatMessage } = useIntl();

  const sourceMapping = (source) => {
    const mapping = {
      metadesk: formatMessage({ id: "cdp.source.ticket" }),
      csv: formatMessage({ id: "cdp.source.csv" }),
      attribution: formatMessage({ id: "cdp.source.attributionLink" }),
      contract: formatMessage({ id: "cdp.source.smartContract" }),
      singleUser: formatMessage({ id: "cdp.source.manualInput" }),
      websiteTraffic: formatMessage({ id: "cdp.source.websiteTraffic" }),
      referral: formatMessage({ id: "cdp.source.referral" }),
      webhookUser: formatMessage({ id: "cdp.source.webhook" }),
      notificationUser: formatMessage({ id: "cdp.source.notificationUser" }),
    };

    if (source === "all") return mapping;

    const typeKey = mapping[source];
    if (typeKey) return typeKey;

    return camelCaseToTitle(source);
  };

  const lastEngagementMapping = (lastEngagementType) => {
    const mapping = {
      ticketChat: formatMessage({ id: "cdp.engagement.ticketChat" }),
      campaignClick: formatMessage({ id: "cdp.engagement.campaignClick" }),
      campaignConversion: formatMessage({
        id: "cdp.engagement.campaignConversion",
      }),
      widgetNotifRead: formatMessage({ id: "cdp.engagement.widgtNotifcation" }),
      csvImport: formatMessage({ id: "cdp.engagement.importByCsv" }),
      webhookImport: formatMessage({ id: "cdp.engagement.importByWebhook" }),
      manualImport: formatMessage({ id: "cdp.engagement.manualImport" }),
      contractImport: formatMessage({ id: "cdp.engagement.contractImport" }),
      websiteTraffic: formatMessage({ id: "cdp.engagement.websiteTraffic" }),
      subscriptionOptIn: formatMessage({
        id: "cdp.engagement.subscriptionOptIn",
      }),
    };

    if (lastEngagementType === "all") return mapping;

    const typeKey = mapping[lastEngagementType];
    if (typeKey) return typeKey;

    return camelCaseToTitle(lastEngagementType);
  };

  return { sourceMapping, lastEngagementMapping };
}
